import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';

// import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  AuthInterceptor,
  AuthorizeGuard,
  ConfigService,
  UserService,
  SharedModule,
  GuestService,
  RoleService,
  GuestRoleService,
} from './shared';
import { SponsorModule } from './sponsor/sponsor.module';
import { AppRoutingModule } from './app-routing.module';
import { AdminModule } from './admin/admin.module';
import { SponsorService } from './shared/services/sponsor.service';
import { SponsorGuard } from './shared/guards/sponsor.guard';
import { AdminGuard } from './shared/guards/admin.guard';
import { LoginComponent } from './login.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

@NgModule({
  declarations: [AppComponent, LoginComponent],
  imports: [
    BrowserModule,
    MatButtonModule,
    MatSnackBarModule,
    MatCardModule,
    SharedModule,
    SponsorModule,
    AdminModule,
    AppRoutingModule,
    // rootRouting
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: 'dynamic' },
    },
    AuthorizeGuard,
    SponsorGuard,
    AdminGuard,
    ConfigService,
    UserService,
    GuestService,
    RoleService,
    GuestRoleService,
    SponsorService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
